import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";

export const GlobalStyle = createGlobalStyle`
	${normalize}
	
	html {
		box-sizing: border-box;
		zoom: 0.85;
	} 

	*, ::after, ::before {
		box-sizing: inherit;
	}

	body {
		font-family: 'Poppins', sans-serif;
		background: ${({ theme }) => theme.color.whisper};
		margin: 0;
	}
`;